import {
  Box,
  formatNumber,
  Inline,
  Tooltip,
  Typography,
} from '@omnipresentgroup/design-system';
import { InvoiceReportNetSuiteType } from '@omnipresentgroup/types';

type Props = {
  type: InvoiceReportNetSuiteType;
  amount: number;
  currency: string;
  parentTransactionId?: string;
};

export const AmountCell = ({
  type,
  amount,
  currency,
  parentTransactionId,
}: Props) => {
  if (type === InvoiceReportNetSuiteType.CREDIT && parentTransactionId) {
    return (
      <Box>
        <Tooltip
          id="show-credit-note-relation"
          description={
            <Inline gap="4">
              <Typography color="subtle" as="span" size="12" weight="medium">
                Credit for
              </Typography>
              <Typography as="span" color="subtle" size="12">
                {parentTransactionId}
              </Typography>
            </Inline>
          }
        >
          <Typography
            hideParagraphSpacing
            as="p"
            size="14"
            textDecoration="underline"
          >
            {formatNumber({
              input: amount,
              currency,
              currencySign: 'accounting',
            })}
          </Typography>
        </Tooltip>
        <Typography hideParagraphSpacing as="p" size="14">
          Credit
        </Typography>
      </Box>
    );
  }
  return (
    <Typography as="span" size="14">
      {formatNumber({
        input: amount,
        currency,
        currencySign: 'accounting',
      })}
    </Typography>
  );
};
